/**
 * Shared runtime environment helpers that rely on Node's notion of the environment.
 * These are safe to import from both server and client modules because Next.js
 * statically inlines `process.env.NODE_ENV` during compilation.
 */

const nodeEnvironment = process.env.NODE_ENV ?? 'development';

/**
 * Raw Node.js environment string surfaced by bundlers like Next.js.
 * Useful when you need the canonical runtime mode without relying on custom env wiring.
 */
export const nodeRuntimeEnv = nodeEnvironment;
/**
 * True when the runtime (server or client bundle) is compiled in development mode.
 * Next.js inlines this during build, so the check has zero runtime cost.
 */
export const isDevelopmentRuntime = nodeEnvironment === 'development';
/** Convenience helper for production bundles. */
export function isProductionRuntime(): boolean {
  return nodeEnvironment === 'production';
}
/** Convenience flag for test runners such as Vitest. */
export const isTestRuntime = nodeEnvironment === 'test';
